import './FrontEnd.scss';

const COOKIE_NAME = 'disneyrewards-cardmember-type';
let cachedLoggedIn = null;

// Helper to get cookie value
function getCookie(name) {
    if (typeof document === 'undefined' || typeof document.cookie !== 'string') {
        return '';
    }

    const prefix = `${name}=`;
    const cookie = document.cookie
        .split(';')
        .map((item) => item.trim())
        .find((item) => item.startsWith(prefix));

    if (!cookie) {
        return '';
    }

    const value = cookie.slice(prefix.length);

    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
}

function handleOneIDVisibility(loggedIn) {
    document.querySelectorAll('[data-oneid-visibility]').forEach((el) => {
        const element = el;
        const footnotes = element.querySelectorAll('sup.single-footnote');
        const visibility = element.getAttribute('data-oneid-visibility');

        const shouldHide =
            (visibility === 'hide-when-logged-in' && loggedIn) ||
            (visibility === 'hide-when-not-logged-in' && !loggedIn);

        element.hidden = shouldHide;

        footnotes.forEach((footnote) => {
            footnote.classList.toggle('dr-disable-footnote', shouldHide);
        });
    });
}

function isLoggedIn(type) {
    return ['classic', 'premier', 'inspire', 'cardmember'].includes(type);
}

document.addEventListener('DOMContentLoaded', () => {
    const cardmemberType = getCookie(COOKIE_NAME);
    const loggedIn = isLoggedIn(cardmemberType);

    if (cachedLoggedIn !== loggedIn) {
        cachedLoggedIn = loggedIn;
        handleOneIDVisibility(loggedIn);
    }
});

window.addEventListener('cardMemberTypeChanged', (e) => {
    const cardmemberType = e.detail?.cardMemberType || '';
    const loggedIn = isLoggedIn(cardmemberType);

    if (cachedLoggedIn !== loggedIn) {
        cachedLoggedIn = loggedIn;
        handleOneIDVisibility(loggedIn);
    }
});
